import { MATERIAL_URL, PERSONS_URL } from "../constants";
export enum EntityType {
    BASKET = 'basket',
    EXPEDITION = 'expedition',
    EXCAVATION = 'excavation',
    SURVEY = 'survey',
    CONSERVATION_REPORT = 'conservation_report',
    HACHRAZA = 'hachraza',
    LICENSE = 'license',
    LOCUS = 'locus',
    OBJECT = 'object',
    MANUSCRIPT = 'manuscript',
    PUBLICATION = 'publication',
    PHOTOGRAMMETRIC = 'photogrammetric_model',
    YAZAM_REPORT = 'yazam_report',
    SCIENTIFIC_ARCHIVE_DOCUMENTS = 'scientific_archive_documents',
    SCIENTIFIC_ARCHIVE_FOLDERS = 'scientific_archive_folders',
    CONSERVATION_ARCHIVE_DOCUMENTS = 'conservation_archive_documents',
    CONSERVATION_ARCHIVE_FOLDERS = 'conservation_archive_folders',
    PERSON= 'person',
    DECISION_LETTER= 'decision_letter',
    FRAGMENT = 'fragment',
    DANA_PDF = 'dana_pdf',
    ORTHOPHOTO = 'orthophoto',
    COIN = 'coin',
    PLASTER_SAMPLE = 'plaster_sample',
    HB_SECTION = 'hb_section',
    HB_FINDING = 'hb_finding'

  }
  export enum EntityTypePlural {
    BASKETS = 'baskets',
    EXPEDITIONS = 'expeditions',
    EXCAVATIONS = 'excavations',
    SURVEYS = 'surveys',
    CONSERVATION_REPORTS = 'conservation_reports',
    HACHRAZOT = 'hachrazot',
    LICENSES = 'licenses',
    LOCI = 'loci',
    MANUSCRIPTS = 'manuscripts',
    OBJECTS = 'objects',
    PUBLICATIONS = 'publications',
    PHOTOGRAMMETRICS = 'photogrammetric_models',
    YAZAM_REPORTS = 'yazam_reports',
    SCIENTIFIC_ARCHIVE_DOCUMENTS = 'scientific_archive_documents',
    SCIENTIFIC_ARCHIVE_FOLDERS = 'scientific_archive_folders',
    CONSERVATION_ARCHIVE_DOCUMENTS = 'conservation_archive_documents',
    CONSERVATION_ARCHIVE_FOLDERS = 'conservation_archive_folders',
    PERSONS = 'persons',
    DECISION_LETTERS= 'decision_letters',
    FRAGMENTS = 'fragments',
    DANA_PDFS = 'dana_pdfs',
    ORTHOPHOTOS = 'orthophotos',
    COINS = 'coins',
    PLASTER_SAMPLES = 'plaster_samples',
    HB_SECTIONS = 'hb_sections',
    HB_FINDINGS = 'hb_findings'
  }

  export enum EntityTypeName {
    BASKET = 'סלים (DANA)',
    EXPEDITION = 'משלחות  חפירה',
    EXCAVATION = 'חפירות',
    SURVEY = 'סקרים',
    CONSERVATION_REPORT = 'דוחות שימור מסכמים',
    HACHRAZA = 'אתרי עתיקות מוכרזים',
    LICENSE = 'רישיונות חפירה',
    LOCUS = 'לוקוסים (DANA)',
    OBJECTS = 'פריטים באוצרות המדינה',
    PUBLICATION = 'פרסומי רשות העתיקות',
    PHOTOGRAMMETRIC = 'מודלים תלת-מימדיים',
    YAZAM_REPORT = 'דוחות ליזם',
    SCIENTIFIC_ARCHIVE_DOCUMENTS = 'מסמכי ארכיון מדעי',
    SCIENTIFIC_ARCHIVE_FOLDERS =  'תיקייות ארכיון מדעי',
    CONSERVATION_ARCHIVE_DOCUMENTS = 'מסמכי ארכיון שימור',
    CONSERVATION_ARCHIVE_FOLDERS = 'תיקיות ארכיון שימור',
    PERSON = 'חוקרים',
    DECISION_LETTER= 'מכתבי החלטה לבדיקת תכניות',
    FRAGMENT = 'קטעים ממגילות מדבר יהודה',
    MANUSCRIPT = 'מגילות מדבר יהודה',
    DANA_PDF = 'תיקי חפירה דיגיטליים',
    ORTHOPHOTO = 'אורטופותו',
    COIN = 'מטבעות',
    PLASTER_SAMPLE = 'דגימות מעבדה',
    HB_SECTION = 'חתכי בדיקה'
  }

  export const pluralToSingular = {
    [EntityTypePlural.BASKETS]: EntityType.BASKET,
    [EntityTypePlural.EXPEDITIONS]: EntityType.EXPEDITION,
    [EntityTypePlural.EXCAVATIONS]: EntityType.EXCAVATION,
    [EntityTypePlural.SURVEYS]: EntityType.SURVEY,
    [EntityTypePlural.CONSERVATION_REPORTS]: EntityType.CONSERVATION_REPORT,
    [EntityTypePlural.HACHRAZOT]: EntityType.HACHRAZA,
    [EntityTypePlural.LICENSES]: EntityType.LICENSE,
    [EntityTypePlural.LOCI]: EntityType.LOCUS,
    [EntityTypePlural.OBJECTS]: EntityType.OBJECT,
    [EntityTypePlural.PUBLICATIONS]: EntityType.PUBLICATION,
    [EntityTypePlural.PHOTOGRAMMETRICS]: EntityType.PHOTOGRAMMETRIC,
    [EntityTypePlural.ORTHOPHOTOS]: EntityType.ORTHOPHOTO,
    [EntityTypePlural.YAZAM_REPORTS]: EntityType.YAZAM_REPORT,
    [EntityTypePlural.SCIENTIFIC_ARCHIVE_DOCUMENTS]: EntityType.SCIENTIFIC_ARCHIVE_DOCUMENTS,
    [EntityTypePlural.SCIENTIFIC_ARCHIVE_FOLDERS]: EntityType.SCIENTIFIC_ARCHIVE_FOLDERS,
    [EntityTypePlural.CONSERVATION_ARCHIVE_DOCUMENTS]: EntityType.CONSERVATION_ARCHIVE_DOCUMENTS,
    [EntityTypePlural.CONSERVATION_ARCHIVE_FOLDERS]: EntityType.CONSERVATION_ARCHIVE_FOLDERS,
    [EntityTypePlural.PERSONS]: EntityType.PERSON,
    [EntityTypePlural.FRAGMENTS]: EntityType.FRAGMENT,
    [EntityTypePlural.MANUSCRIPTS]: EntityType.MANUSCRIPT,
    [EntityTypePlural.COINS]: EntityType.COIN,
    [EntityTypePlural.DANA_PDFS]: EntityType.DANA_PDF,
    [EntityTypePlural.PLASTER_SAMPLES]: EntityType.PLASTER_SAMPLE,
    [EntityTypePlural.HB_SECTIONS]: EntityType.HB_SECTION,
    [EntityTypePlural.HB_FINDINGS]: EntityType.HB_FINDING
  }
